module.exports = __webpack_public_path__ + "media/images/athletes/104-2874306d2124a11929d44420ab567fd0.png";